import { request, url } from '@tencent/ppd-base-libs';
import { PageResult } from '@/types/we-coupons';

// debugger模式处理
const isDebugger = url.getUrlParam('wecoupon_debugger') === '1';
const debugOptions = isDebugger ? { is_debug: 1 } : {};

/**
 * 搜索商户并输出券列表的
 * @param key 按商户搜索，用户输入的关键字
 * @param offset 数据偏移量
 * @param limit 获取数据个数
 * @returns
 */
export async function getCouponListBySpKey(key: string, offset: number, limit: number):
Promise<PageResult<any>> {
  const url = '/app/promotion/we_coupon/we_coupon_search_by_sp.cgi';
  const {
    has_next_page: hasNextPage,
    total_num: totalCount,
    coupon_array: dataList,
  } = await request.get(url, { params: { key, offset, limit, ...debugOptions } });
  return { hasNextPage, totalCount, dataList };
}

/**
 * 获取收藏分类下的券列表信息
 * @param offset 数据偏移量
 * @param limit 获取数据个数
 * @returns
 */
export async function getFavoritesCouponList(offset: number, limit: number):
Promise<PageResult<any>> {
  const url = '/app/promotion/we_coupon/we_coupon_subc_cplist.cgi';
  const {
    has_next_page: hasNextPage,
    total_num: totalCount,
    coupon_array: dataList,
  } = await request.get(url, { params: { offset, limit, ...debugOptions } });
  return { hasNextPage, totalCount, dataList };
}
